const ITEMS = [
  "Mini Basque Cheesecakes",
  "Chocochunk Cookie Pies",
  "Hazelnut Cookie Pie",
  "Pave Chocolates",
  "Dadar, Mumbai",
];

function Row({ hidden = false }) {
  return (
    <div aria-hidden={hidden} className="flex items-center shrink-0">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="font-display italic font-medium text-2xl sm:text-4xl px-6 sm:px-10 whitespace-nowrap">
            {item}
          </span>
          <span className="text-gold text-lg sm:text-2xl" aria-hidden="true">
            ✶
          </span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section className="bg-ink text-eggshell py-6 sm:py-8 overflow-hidden border-y-[3px] border-ink rotate-0">
      <div className="flex w-max marquee-track">
        <Row />
        <Row hidden />
      </div>
    </section>
  );
}
